import { render, staticRenderFns } from "./GroupMailList.vue?vue&type=template&id=d1dfa5b2&scoped=true&"
import script from "./GroupMailList.vue?vue&type=script&lang=js&"
export * from "./GroupMailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1dfa5b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VListItemContent})
